import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import RbacView from "./rbac.view";

const useRbacRoutes = () => (
  <Route path={pages.rbac.path} element={<RbacView />}>
    <Route index element={<RbacView />} />
  </Route>
);

export default useRbacRoutes;
